import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, FileTextIcon } from 'lucide-react';
import { Lightbox } from './Lightbox';
import { Badge } from './Badge';
import type { Candidate } from '../types/landing';
type CandidateProfileModalProps = {
  candidate: Candidate | null;
  total: number;
  onClose: () => void;
  onNavigate: (dir: 1 | -1) => void;
};
export function CandidateProfileModal({
  candidate,
  total,
  onClose,
  onNavigate
}: CandidateProfileModalProps) {
  return <Lightbox open={candidate !== null} onClose={onClose} labelledBy="candidate-profile-title" data-id="element-75" data-mp="1xz0aw9iq3g4j">
      <AnimatePresence mode="wait" initial={false} data-id="element-76" data-mp="1jadu03dg6gb7">
        {candidate && <motion.div key={candidate.id} initial={{
        opacity: 0,
        x: 24
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -24
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="grid md:grid-cols-[minmax(0,340px)_1fr]" data-id="element-77" data-mp="1oa0cosc1oore">
            <div className="bg-[#F4F7FC]" data-id="element-78" data-mp="3hon2ttbtmlv0">
              <img src={candidate.photo} alt={candidate.name} className="aspect-[4/5] h-full max-h-[46vh] w-full object-cover object-top md:max-h-none" data-id="element-79" data-mp="3hl918nazegom" />
            </div>

            <div className="flex flex-col gap-6 p-6 sm:p-10" data-id="element-80" data-mp="3mm591bygemzb">
              <Badge variant="secondary" size="sm" className="self-start" data-id="element-81" data-mp="3mku2j4dmj14i">
                Vota Lista No. 1
              </Badge>
              <div data-id="element-82" data-mp="3vfi86vn42ktu">
                <h2 id="candidate-profile-title" className="type-h3 text-primary" data-id="element-83" data-mp="3vdyrx51gg9s2">
                  {candidate.name}
                </h2>
                <p className="mt-2 text-base text-foreground/70" data-id="element-84" data-mp="e4shpm18jsnv">{candidate.company}</p>
              </div>

              <div className="flex h-28 items-center justify-start rounded-2xl border border-primary/10 bg-white px-5 py-3" data-id="element-85" data-mp="95xsa18rj5us">
                <img src={candidate.companyLogo} alt={`Logo de ${candidate.company}`} className="max-h-full max-w-[260px] object-contain" data-id="element-86" data-mp="2azomsjmn5xr0" />
              </div>

              {candidate.bio ? <div className="space-y-3 text-[15px] leading-relaxed text-foreground/80" data-id="element-87" data-mp="34qyvgt2z03gr">
                  {candidate.bio.split('\n').map((p, i) => <p key={i} data-id="element-88" data-mp="3eo3fond99oux" data-mpi={i}>{p}</p>)}
                  {candidate.highlights && <ul className="list-disc space-y-1 pl-5" data-id="element-89" data-mp="3jldf8vuczgwh">
                      {candidate.highlights.map(h => <li key={h} data-id="element-90" data-mp="3nlxcs0iugmj5">{h}</li>)}
                    </ul>}
                </div> : <div className="flex flex-1 flex-col items-center justify-center rounded-2xl border border-dashed border-primary/20 bg-[#F8FAFD] px-6 py-8 text-center" data-id="element-91" data-mp="18p07y3r8515">
                  <FileTextIcon className="h-6 w-6 text-primary/50" data-id="element-92" data-mp="65fgalfk70mk" />
                  <p className="mt-3 text-sm font-semibold text-primary" data-id="element-93" data-mp="b6v4ungy3p9p">Perfil en preparación</p>
                  <p className="mt-1 text-sm text-foreground/60" data-id="element-94" data-mp="1vpytldpnxyry">
                    Muy pronto conocerás la trayectoria y propuestas de este candidato.
                  </p>
                </div>}

              <div className="mt-auto flex items-center justify-between gap-3 border-t border-primary/10 pt-5" data-id="element-95" data-mp="1lsamdoaveysw">
                <button type="button" onClick={() => onNavigate(-1)} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold text-primary transition hover:bg-primary/5" data-id="element-96" data-mp="1gthlcvcrt09m">
                  <ChevronLeftIcon className="h-4 w-4" data-id="element-97" data-mp="24n96f3i4pvyz" /> Anterior
                </button>
                <button type="button" onClick={() => onNavigate(1)} className="inline-flex items-center gap-1.5 rounded-full border border-primary/20 px-4 py-2 text-sm font-semibold text-primary transition hover:bg-primary hover:text-white" data-id="element-98" data-mp="1zpg0mbkqn3z8">
                  Siguiente <ChevronRightIcon className="h-4 w-4" data-id="element-99" data-mp="2cyq1sp1tw91j" />
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </Lightbox>;
}